import { jsxs as t, jsx as s } from "react/jsx-runtime";
import { forwardRef as u, useState as x, useEffect as d } from "react";
import S from "classnames";
import i from "./spinner.module.less.js";
import { IS_IOS as b } from "../utils.js";
const h = u(
  function({ className: c, children: r, timedContent: e, size: n = "md", ...a }, m) {
    const [p, o] = x(r);
    return d(() => {
      o(r), Object.entries(e || {}).forEach(
        ([f, l]) => setTimeout(() => o(l), Number(f))
      );
    }, [e, r]), /* @__PURE__ */ t(
      "span",
      {
        ...a,
        "aria-live": "polite",
        className: S(i.spinner, i[n], c),
        ref: m,
        role: b ? void 0 : "progressbar",
        tabIndex: 0,
        children: [
          /* @__PURE__ */ t("svg", { viewBox: "25 25 50 50", "aria-hidden": "true", children: [
            /* @__PURE__ */ s("circle", { cx: "50", cy: "50", r: "20" }),
            /* @__PURE__ */ s("circle", { cx: "50", cy: "50", r: "20" })
          ] }),
          p
        ]
      }
    );
  }
);
export {
  h as Spinner
};
//# sourceMappingURL=spinner.js.map
